// English is dev-only scaffolding (the `?locale=en` toggle); Korean is the only shipped locale
// (RULE_I18N_KO_ONLY_001 — no language switcher ships). No LANGUAGE_OPTIONS / picker by design.
export type LanguageCode = 'en' | 'ko' | 'vi';

export const DEFAULT_LANGUAGE: LanguageCode = 'ko';

export const LANGUAGE_STORAGE_KEY = 'smart-home-care-language';
